import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { addNotification } from "../../store/actions/notifierActions";

const useClipboard = () => {
  const dispatch = useDispatch();

  const copy = useCallback(
    async (text, successMsg = "Text Copied", errorMsg = "Copying Text failed") => {
      try {
        await navigator.clipboard.writeText(text);
        dispatch(addNotification({ message: successMsg, options: { variant: "success" } }));
      } catch (error) {
        dispatch(addNotification({ message: errorMsg, options: { variant: "error" } }));
      }
    },
    [dispatch],
  );

  return copy;
};

export default useClipboard;
